import { useState, useEffect } from 'react';
import Grid from '@material-ui/core/Grid';
import GridComponent from '../grid/GridComponent.component';
import CustomList from './CustomList.component';
import { intersection, not, union, notObject } from '../../utils/sets/Sets';
import { TransferListInterface } from './interfaces/TransferList';
import Progress from '../progress/Progress.component';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import Button from '@material-ui/core/Button';

export default function TransferList<T>({ titelLeft, titleRight, list, listAvailable, handleSubmit, request, propertyName, blockSubmitTransferList = false }: TransferListInterface<T>) {

    const [value] = useState<T[]>([...listAvailable]);
    const [valueAvailable, setValueAvailable] = useState<T[]>([]);
    const [checked, setChecked] = useState<T[]>([]);
    const [valueSelect, setValueSelect] = useState<T[]>([]);
    const valueChecked = intersection(checked, valueAvailable);
    const valueSelectChecked = intersection(checked, valueSelect);

    useEffect(() => {
        setValueSelect(list || []);
        if (listAvailable.length || list.length) {
            setValueAvailable(notObject(listAvailable, list || [], propertyName.id));
        }
    }, [list, value, propertyName.id, request]);

    const handleToggle = (value: any) => () => {
        if (value.hasOwnProperty(propertyName.id)) {
            const currentIndex = checked.some((el: any) => el[propertyName.id] === value[propertyName.id]);
            let newChecked = [...checked];
            if (!currentIndex) {
                newChecked.push(value);
            } else {
                newChecked = newChecked.filter((el: any) => el[propertyName.id] !== value[propertyName.id]);
            }
            setChecked(newChecked);
        }
    };

    const numberOfChecked = (items: T[]) => intersection(checked, items).length;

    const handleToggleAll = (items: T[]) => () => {
        if (numberOfChecked(items) === items.length) {
            setChecked(not(checked, items));
        } else {
            setChecked(union(checked, items));
        }
    };

    const handleCheckedvalueSelect = () => {
        setValueSelect(valueSelect.concat(valueChecked));
        setValueAvailable(not(valueAvailable, valueChecked));
        setChecked(not(checked, valueChecked));
        if (!blockSubmitTransferList) {
            handleSubmit(valueChecked, 'ADD');
        }
    };

    const handleCheckedfuncionality = () => {
        setValueAvailable(valueAvailable.concat(valueSelectChecked));
        setValueSelect(not(valueSelect, valueSelectChecked));
        setChecked(not(checked, valueSelectChecked));
        if (!blockSubmitTransferList) {
            handleSubmit(valueSelectChecked, 'DELETE');
        }
    };

    if (request) {
        return <Progress open={request} position="relative" />
    }

    if (!list.length && !listAvailable.length) {
        return <> </>
    }

    return (
        <>
            <GridComponent spacing={2} justify="center" >
                <Grid item xs={12} sm={12} md={5}>
                    <CustomList
                        title={titleRight}
                        items={valueAvailable}
                        handleToggle={handleToggle}
                        handleToggleAll={handleToggleAll}
                        checked={checked}
                        propertyName={propertyName}
                    />
                </Grid>
                <Grid item xs={12} sm={12} md={2}>
                    <GridComponent direction="column" alignItems="center">
                        <Button
                            variant="outlined"
                            onClick={handleCheckedvalueSelect}
                            disabled={!valueChecked.length}
                            title=''
                            startIcon={<ArrowForwardIosIcon color="primary" />}
                            style={{ paddingRight: 10, marginBottom: 10 }}
                            size='large'
                        />
                        <Button
                            variant="outlined"
                            onClick={handleCheckedfuncionality}
                            disabled={!valueSelectChecked.length}
                            title=''
                            size='large'
                            startIcon={<ArrowBackIosIcon color="primary" />}
                            style={{ paddingRight: 0 }}
                        />
                    </GridComponent>
                </Grid>
                <Grid item xs={12} sm={12} md={5}>
                    <CustomList
                        title={titelLeft}
                        items={valueSelect}
                        handleToggle={handleToggle}
                        handleToggleAll={handleToggleAll}
                        checked={checked}
                        propertyName={propertyName}
                    />
                </Grid>
            </GridComponent>
            {blockSubmitTransferList && <GridComponent justify="flex-end" margin="30px 0px 20px 0px">
                <Button variant='contained' size='medium'  style={{borderRadius:"8px"}} onClick={() => handleSubmit(valueSelect)}>Atribuir</Button>
            </GridComponent>}
        </>
    );
}